(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["layouthub_sale_notification"] && !Shopify.designMode) return;
  try {
    
 (function(){
	let dom = document.querySelector('#lh-sale-notification-data');
 	var box = document.createElement('div');
		box.classList.add('lh-sale-popup');
	var itv = null;
	 
	box.addEventListener('click', function(e){
		let target = e.target;
		console.log(target);
		if(target.classList.contains('lh-close-btn')){
			box.classList.add('lh-hide'); 
			setCookie('lh-sale-notification',new Date().getTime(), 7)
			clearInterval(itv);
		}
	}); 
	if(dom)
	{
		let data = JSON.parse(dom.innerHTML);
		if(data && data.products && data.products.length )
		{
			
			box.dataset.position=data.settings.position;
            document.body.appendChild(box);
            var products = data.products.map(function(item){
				item.time_ago = prettyDate(item.time, data.settings)
				let now = new Date();
				let day = now.getDate();
				let rand = getRndInteger(1,day);
				now.setDate(day - rand);
				item.random_time_ago =  prettyDate(now, data.settings);
				item.random_number = rand;
				return item;
        	});
        	console.log(products);
        	function displayPopup()
	        {
					 box.classList.add('lh-hide');
	              if(products.length)
	              {
	                let product = products.pop();
	                let html = renderHtml(data.settings,product);
	               
	                setTimeout(function(){
	                  box.innerHTML = html;
	                  box.classList.remove('lh-hide');
	                },data.settings.delay_duration ? data.settings.delay_duration  * 1000: 5000);
	              }

	         }
	         let cc = getCookie('lh-sale-notification');
            !cc && setTimeout(function(){
				itv = setInterval(displayPopup,data.settings.duration ? data.settings.duration  * 1000 : 50000);
	            displayPopup();
        	},data.settings.delay? data.settings.delay  * 1000: 5000);
		}
	}
	function getRndInteger(min, max) {
	  return Math.floor(Math.random() * (max - min) ) + min;
	}
	function prettyDate(time, settings) {
		    var date = typeof time === 'string' ?  new Date(new Date(time).toLocaleString()) : time,
		        diff = (((new Date()).getTime() - date.getTime()) / 1000),
		        day_diff = Math.floor(diff / 86400);
		    var year = date.getFullYear(),
		        month = date.getMonth()+1,
		        day = date.getDate();

		    if (isNaN(day_diff) || day_diff < 0 || day_diff >= 31)
		        return (
		            year.toString()+'-'
		            +((month<10) ? '0'+month.toString() : month.toString())+'-'
		            +((day<10) ? '0'+day.toString() : day.toString())
		        );

		    var r =
		    ( 
		        (
		            day_diff == 0 && 
		            (
		                (diff < 60 && (settings.trans_just_now ?  settings.trans_just_now : "just now"))
		                || (diff < 120 &&  (settings.trans_minute_ago? settings.trans_minute_ago: "1 minute ago"))
		                || (diff < 3600 && Math.floor(diff / 60) + (settings.trans_minutes_ago ? settings.trans_minutes_ago : " minutes ago"))
		                || (diff < 7200 && (settings.trans_hour_ago ? settings.trans_hour_ago : "1 hour ago"))
		                || (diff < 86400 && Math.floor(diff / 3600) +  (settings.trans_hours_ago ? settings.trans_hours_ago : " hours ago") )
		            )
		        )
		        || (day_diff == 1 && (settings.trans_yesterday ? settings.trans_yesterday : "Yesterday"))
		        || (day_diff < 7 && day_diff + (settings.trans_days_ago ? settings.trans_days_ago : " days ago"))
		        || (day_diff < 31 && Math.ceil(day_diff / 7) + ( settings.trans_weeks_ago? settings.trans_weeks_ago : " weeks ago"))
		    );
		    return r;
		}
	function getSizedImageUrl(t, e) {
        if (null == e)
            return t;
        if ("master" == e)
            return removeProtocol(t);
        var o = t.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);
        if (null == o)
            return null;
        var i = t.split(o[0])
          , r = o[0];
        return removeProtocol(i[0] + "_" + e + r)
    }
    function removeProtocol(t) {
        return t.replace(/http(s)?:/, "")
    }
    function setCookie(cname, cvalue, exdays) {
	  var d = new Date();
	  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
	  var expires = "expires="+d.toUTCString();
	  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
	}

	function getCookie(cname) {
	  var name = cname + "=";
	  var ca = document.cookie.split(';');
	  for(var i = 0; i < ca.length; i++) {
	    var c = ca[i];
	    while (c.charAt(0) == ' ') {
	      c = c.substring(1);
	    }
	    if (c.indexOf(name) == 0) {
	      return c.substring(name.length, c.length);
	    }
	  }
	  return "";
	}
	function renderHtml(settings,item)
	{
		return `

			
              <div class="lh-sale-popup-wrapper" style="background-color: ${settings.background}">
                  <div class="lh-sale-popup-thumb">
                      <div class="np-col-img" style="background-image: url('${ getSizedImageUrl(item.image,'medium')}')"></div>
                  </div>
                  <div class="lh-sale-popup-attributes">
                     <div class="lh-sale-popup-header">
                          <p class="lh-card-text lh-buyer-name" style="color:${settings.header_color}!important;">${parseString(settings.header,item)}</p>
                      </div>
                      <div class="lh-sale-popup-content">
                          <h5 class="lh-card-title">
                            <a class="lh-sale-popup-link" target="_blank" href="${item.url}" style="color:${settings.content_color}!important;">
                              ${parseString(settings.content,item)}
                            </a>
                          </h5>
                      </div>
                      <div class="lh-sale-popup-footer">
                          <span class="purchased-time" style="color:${settings.footer_color}!important;">${parseString(settings.footer,item)} </span>
                      </div>
                  </div>
              </div>
              <a href="javascript:;" class="lh-close-btn"></a>
            


		`;
	}
	function parseString(str,variables)
	{
		if(!str) return "";
		const regex = /\{\{\s*?([\w]+)\s*?\}\}/;
		let m;
		while(m=str.match(regex))
		{
			str = str.replace(regex,variables[m[1]] || variables[m[1]]=== "" ? variables[m[1]] : encodeURIComponent(m[0] ) )
		}
		return decodeURIComponent(str);
	}
})()



  } catch(e) { console.error(e); }
})();
})();
